import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { X, Download, ZoomIn, ZoomOut } from "lucide-react";
import { toast } from "sonner";

export function ImageViewer({ src, onClose }) {
  const [scale, setScale] = useState(1);
  const pinch = useRef(null);
  const lastTap = useRef(0);

  const clamp = (s) => Math.min(4, Math.max(1, s));
  const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);

  const onTouchStart = (e) => {
    if (e.touches.length === 2) pinch.current = { d: dist(e.touches), s: scale };
    else {
      const now = Date.now();
      if (now - lastTap.current < 300) setScale((s) => (s > 1 ? 1 : 2.5));
      lastTap.current = now;
    }
  };
  const onTouchMove = (e) => {
    if (e.touches.length === 2 && pinch.current) setScale(clamp(pinch.current.s * (dist(e.touches) / pinch.current.d)));
  };

  const save = async () => {
    try {
      const blob = await fetch(src).then((r) => r.blob());
      const ext = (blob.type.split("/")[1] || "jpg").replace("jpeg", "jpg");
      const file = new File([blob], `gjejshqip-${Date.now()}.${ext}`, { type: blob.type });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(file);
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      toast.success("Fotoja u ruajt");
    } catch { toast.error("Fotoja nuk u ruajt"); }
  };

  return createPortal(
    <div className="fixed inset-0 z-[2000] bg-black flex flex-col" data-testid="image-viewer">
      <div className="flex items-center justify-between p-3 text-white">
        <button onClick={onClose} data-testid="image-viewer-close" aria-label="Mbyll" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><X className="w-5 h-5" /></button>
        <div className="flex gap-2">
          <button onClick={() => setScale((s) => clamp(s - 0.5))} data-testid="image-viewer-zoom-out" aria-label="Zvogëlo" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><ZoomOut className="w-5 h-5" /></button>
          <button onClick={() => setScale((s) => clamp(s + 0.5))} data-testid="image-viewer-zoom-in" aria-label="Zmadho" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><ZoomIn className="w-5 h-5" /></button>
          <button onClick={save} data-testid="image-viewer-save" className="h-10 px-4 rounded-full bg-emerald-500 flex items-center gap-1.5 text-sm font-semibold"><Download className="w-4 h-4" />Ruaj</button>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-auto" onClick={(e) => { if (scale === 1 && e.target === e.currentTarget.firstChild) onClose(); }} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={() => { pinch.current = null; }}>
        <div className="min-w-full min-h-full flex items-center justify-center" style={{ width: `${scale * 100}%`, height: `${scale * 100}%` }}>
          <img src={src} alt="" data-testid="image-viewer-img" draggable={false} className="w-full h-full object-contain select-none" />
        </div>
      </div>
    </div>,
    document.body
  );
}
